import { reverse } from "lodash-es";
import { For } from "solid-js";
import { ChessboardView, PiecesSvgSheet } from "~/components/chessboard/Chessboard";
import { createStaticChessState } from "~/utils/chessboard_interface";
import { clsx } from "~/utils/classes";

let wd = [404, 462];
let wdl = [wd[0], wd[1], 1000 - (wd[0] + wd[1])];

export const FakeAnalysis = () => {
	const chessState = createStaticChessState({
		epd: "3rrnk1/p4pbp/1q3np1/1ppP4/5B2/5BPP/PPNQ1P2/R3R1K1 w - -",
		side: "white",
		// nextMove: props.annotation.sanPlus,
	});
	return (
		<div class="flex flex-col items-center justify-center h-screen">
			<PiecesSvgSheet />
			<div class="h-[400px] flex flex-row">
				<div class="w-[10px] h-full mr-4 rounded-sm overflow-hidden" id="wdl">
					<For each={reverse(wdl)}>
						{(wdl, i) => (
							<div
								class={clsx(
									"w-[10px]",
									i() === 0 ? "bg-gray-10" : i() === 1 ? "bg-gray-50" : "bg-gray-70",
								)}
								style={{
									height: `${wdl / 10}%`,
								}}
							></div>
						)}
					</For>
				</div>
				<div class="w-[400px] h-[400px]">
					<ChessboardView chessboardInterface={chessState} />
				</div>
			</div>
		</div>
	);
};
